import { Prop, Component, Watch, Vue } from "vue-property-decorator";
import moment from "moment";
function hasRouted(vue) {
    return (typeof vue["routed"] == "function");
}
function callRouted(vue) {
    if (hasRouted(vue))
        vue["routed"](vue.$route.params, vue.$route.query);
}
Vue.mixin({
    computed: {
        root: function () { return this.$root; },
    },
    created: function () {
        var _this = this;
        if (hasRouted(this)) {
            callRouted(this);
            this.$watch("$route", function () { return callRouted(_this); });
        }
    },
    methods: {
        // TODO replace all of this with i18n formatting functions
        isoDate: function (date) {
            if (!date)
                return null;
            return moment(date).format("DD.MM.YYYY");
        },
        isoDateTime: function (dateTime) {
            if (!dateTime)
                return null;
            return moment(dateTime).format("DD.MM.YYYY HH:mm:ss");
        },
        shortDateTime: function (dateTime) {
            if (!dateTime)
                return null;
            return moment(dateTime).format("DD.MM.YYYY HH:mm");
        },
        join: function (values) {
            if (!values) {
                return "";
            }
            return values.filter(function (v) {
                return v != null && v.length > 0;
            }).join(", ");
        }
    }
});
export { Vue, Component, Prop, Watch };
